import { Tooltip } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';

import { Badge, Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import api from 'services/api';
import './style.css';

interface IConfiguracao {
  configuracaoId: number;
  tag: string | null;
  produtoNome: string | null;
}

interface IConfiguracoesProps {
  label?: string;
  id: string;
  propostaVersaoId: number;
}

export default function ConfiguracoesProposta({
  label,
  id,
  propostaVersaoId,
}: IConfiguracoesProps): JSX.Element {
  const [popoverAberto, setPopoverAberto] = useState(false);
  const [configuracoes, setConfiguracoes] = useState<IConfiguracao[]>([]);

  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const clicouNoBadge = popoverRef.current?.contains(target);

      const clicouNoPopover = (target as HTMLElement)?.closest('.popover');

      if (!clicouNoBadge && !clicouNoPopover) {
        setPopoverAberto(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  async function getInfoConfiguracoes() {
    setPopoverAberto(prev => !prev);
    const response = await api.get(
      `/proposta/versao/configuracao/informacoes/${propostaVersaoId}`,
    );

    setConfiguracoes(response.data);
  }

  const quantidadeLinhas = Math.min(Math.max(configuracoes.length, 1), 8);

  return (
    <div
      ref={popoverRef}
      // style={{
      //   position: 'relative',
      // }}
    >
      <Badge
        id={id}
        color="info"
        role="button"
        onClick={getInfoConfiguracoes}
        style={{ cursor: 'pointer' }}
      >
        Ver configurações
      </Badge>

      {popoverAberto && (
        <Popover
          placement="bottom-end"
          target={id}
          isOpen
          style={{
            position: 'absolute',
            right: '0',
            bottom: '0px',
            transform: 'translateY(2rem)',
          }}
        >
          <div
            style={{
              width: 'max-content',
              maxWidth: 'min(900px, calc(100vw - 2rem))',
              border: '1px solid #000',
              borderRadius: '4px',
              backgroundColor: '#fff',
              boxSizing: 'border-box',
              overflow: 'hidden',
            }}
          >
            <PopoverHeader
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span>{label || 'Configurações'}</span>

              <button
                type="button"
                onClick={() => setPopoverAberto(false)}
                aria-label="Fechar"
                style={{
                  border: 'none',
                  background: 'transparent',
                  fontSize: '1.25rem',
                  lineHeight: 1,
                  cursor: 'pointer',
                  padding: '0 0.25rem',
                  color: '#666',
                }}
              >
                ×
              </button>
            </PopoverHeader>

            <PopoverBody
              style={{
                fontSize: '0.9rem',
                backgroundColor: '#fff',
                boxSizing: 'border-box',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateRows: `repeat(${quantidadeLinhas}, auto)`,
                  gridAutoFlow: 'column',
                  gridAutoColumns: 'minmax(250px, 1fr)',
                  gap: '0.75rem 1.5rem',
                }}
              >
                {configuracoes?.map((configuracao, index) => {
                  const link = `/admin/configuracao/${configuracao.configuracaoId}`;

                  return (
                    <div
                      key={configuracao.configuracaoId ?? index}
                      style={{
                        minWidth: 0,
                        overflowWrap: 'break-word',
                        wordBreak: 'break-word',
                        lineHeight: '1.4',
                      }}
                    >
                      <Tooltip
                        title={
                          <span style={{ fontSize: '0.9rem' }}>
                            Navegar para configuração{' '}
                            {configuracao.configuracaoId}
                          </span>
                        }
                      >
                        <a
                          href={link}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                          className="configuracao-link"
                        >
                          <b>{configuracao.configuracaoId ?? ''}</b>
                          {' - '}
                          {configuracao.produtoNome ?? 'Produto não informado'}
                          {configuracao?.tag ? ` (${configuracao.tag})` : ''}
                        </a>
                      </Tooltip>
                    </div>
                  );
                })}
              </div>
            </PopoverBody>
          </div>
        </Popover>
      )}
    </div>
  );
}
